import type { PromotionStats } from "../api/promotionTypes";

interface Props {
  stats: PromotionStats;
  maxCollections: number;
}

function formatCurrency(value: number): string {
  return `฿${value.toLocaleString("th-TH", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

export function PromotionStatsCards({ stats, maxCollections }: Props) {
  const collectedDisplay = maxCollections > 0
    ? `${stats.collected} / ${maxCollections}`
    : String(stats.collected);

  const collectedPct = maxCollections > 0
    ? Math.round((stats.collected / maxCollections) * 100)
    : null;

  const conversionPct = stats.collected > 0
    ? Math.round((stats.used / stats.collected) * 100)
    : 0;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {/* Collected */}
      <div className="rounded-sm border bg-white p-4">
        <p className="text-sm text-muted-foreground">Collected</p>
        <p className="mt-1 text-3xl font-bold">{collectedDisplay}</p>
        {collectedPct !== null ? (
          <>
            <p className="mt-1 text-sm text-muted-foreground">
              {collectedPct}% claimed
            </p>
            <div className="mt-2 h-1.5 w-full rounded-full bg-gray-100">
              <div
                className="h-full rounded-full bg-blue-500 transition-all"
                style={{ width: `${Math.min(collectedPct, 100)}%` }}
              />
            </div>
          </>
        ) : (
          <p className="mt-1 text-sm text-muted-foreground">Unlimited</p>
        )}
      </div>

      {/* Used */}
      <div className="rounded-sm border bg-white p-4">
        <p className="text-sm text-muted-foreground">Used</p>
        <p className="mt-1 text-3xl font-bold">{stats.used}</p>
        <p className="mt-1 text-sm text-muted-foreground">
          {conversionPct}% of collected
        </p>
      </div>

      {/* Revenue */}
      <div className="rounded-sm border bg-white p-4">
        <p className="text-sm text-muted-foreground">Revenue</p>
        <p className="mt-1 text-3xl font-bold">{formatCurrency(stats.revenue)}</p>
        <p className="mt-1 text-sm text-muted-foreground">from orders using this</p>
      </div>
    </div>
  );
}
